<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Trigger Events
              </div>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                @click="handleRefresh()"
              >
              </q-btn>
              <div>
                <q-btn
                  class="q-ml-md"
                  color="secondary"
                  text-color="accent"
                  no-caps
                  unelevated
                  icon="mdi-download-multiple"
                  @click="downloadMultiple"
                  :disable="filteredTriggers.length > 540"
                >
                </q-btn>
                <q-tooltip>
                  Download All images matching filter ({{
                    filteredTriggers.length
                  }}).
                  {{
                    filteredTriggers.length > 540
                      ? "Warning: To many images are loaded, please filter the images down to a maximum of 540 images for the download"
                      : ""
                  }}
                </q-tooltip>
              </div>
              <div
                v-if="['superAdmin', 'appAdmin'].includes(currentUserData.role)"
              >
                <q-btn
                  class="q-ml-md"
                  color="secondary"
                  text-color="accent"
                  no-caps
                  unelevated
                  :icon="showHidden ? 'mdi-eye-off' : 'mdi-eye'"
                  @click="
                    showHidden = !showHidden;
                    filterTriggerEvents();
                  "
                >
                </q-btn>
                <q-tooltip>
                  Toggle between showing all images and only those not hidden.
                  <br />
                  Currently {{ showHidden ? "" : "not" }} showing all
                </q-tooltip>
              </div>

              <q-btn
                v-if="$q.screen.gt.sm"
                class="q-ml-md"
                color="secondary"
                unelevated
                text-color="accent"
                no-caps
              >
                <q-icon size="xs" name="mdi-calendar" class="q-mr-sm"></q-icon>
                Date Range
                <q-menu
                  :anchor="'bottom left'"
                  :self="`${$q.screen.lt.sm ? 'top middle' : 'top left'}`"
                >
                  <div class="row wrap q-pa-xs">
                    <div
                      class="column"
                      v-if="$q.screen.gt.sm"
                      style="min-width: 140px"
                    >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('today')"
                      >
                        Today
                      </q-btn>
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('yesterday')"
                      >
                        Yesterday
                      </q-btn>
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('thisWeek')"
                        >This Week</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('lastWeek')"
                        >Last Week</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('lastTwoWeeks')"
                        >Last Two Weeks</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('thisMonth')"
                        >This Month</q-btn
                      >
                      <q-btn
                        flat
                        no-caps
                        class="full-width"
                        @click="handleRelativeDate('lastMonth')"
                        >Last Month</q-btn
                      >
                    </div>

                    <q-separator
                      v-if="$q.screen.gt.sm"
                      vertical
                      inset
                      class="q-mx-sm"
                    />

                    <div
                      class="column items-center"
                      @click="selectedRelativeDate = null"
                    >
                      <vc-date-picker
                        id="datePicker"
                        v-model="proxyDate"
                        :model-config="modelConfig"
                        is-range
                        :columns="$screens({ default: 1, xl: 2 })"
                        ref="datePicker2"
                      >
                        <!-- <template
                          v-slot="{ inputValue, inputEvents, updateValue }"
                        >
                          <button @click="updateValue(getDateRange())" />
                        </template> -->
                      </vc-date-picker>
                    </div>
                  </div>
                </q-menu>
              </q-btn>

              <span v-if="$q.screen.gt.sm" class="q-ml-sm dateRangeText">
                {{ dateRange.from }} ~ {{ dateRange.to }}
              </span>

              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-calendar"
                v-if="$q.screen.lt.md"
                @click="dateRangeDialog = true"
              >
              </q-btn>

              <q-select
                style="top: -5px; position: relative; left: 20px"
                dense
                v-model="eventsPerPage"
                :options="[10, 25, 50, 75, 100, 200]"
                @input="pagination"
              >
              </q-select>

              <q-space />
              <q-input
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="filteredTriggers && !triggerEventsLoading">
              <q-scroll-area style="height: calc(100vh - 220px) !important">
                <div class="photoGrid">
                  <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                  <div
                    class="q-pa-none"
                    v-for="(event, index) in page"
                    :key="`event_${index}`"
                  >
                    <q-card
                      @click="
                        viewDetailsDialog = true;
                        formData = event;
                        viewedEventIndex =
                          (currentPage - 1) * eventsPerPage + index;
                        eventClicked(event);
                      "
                      class="triggerEventCard q-ma-none cursor-pointer"
                    >
                      <q-card-section
                        class="q-pa-none"
                        style="width: 200px; height: 150px;"
                        :style="
                          `rotate: ${getRotation(
                            event
                          )}deg; max-height: 200px; max-width: ${
                            getRotation(event) == 90 ||
                            getRotation(event) == 270
                              ? '150px'
                              : '200px'
                          }`
                        "
                      >
                        <q-img
                          v-if="!event.rb_data"
                          loading="lazy"
                          no-spinner
                          contain
                          :src="
                            `https://flexi-comms-trigger-events${
                              apiUrl == 'https://api.flexi-comms.com'
                                ? '-live'
                                : '-live'
                            }.s3.ap-southeast-2.amazonaws.com/${
                              event.id
                            }-triggerEvent.${event.fileType}`
                          "
                        >
                        </q-img>
                        <div
                          v-else
                          style="height: 150px; width: 200px"
                          class="bg-primary"
                        ></div>
                      </q-card-section>
                      <q-card-section class="q-pa-sm">
                        <div class="row">
                          <div class="col-12">
                            <q-chip
                              v-if="event.overlays && event.overlays.length > 0 && shouldShowOverlays(event)" 
                              dense
                              style="font-weight: normal;color:white"
                              color="green"
                            >
                              Overlays
                            </q-chip>
                            <q-chip
                              v-if="event.deviceType"
                              dense
                              style="font-weight: bold;"
                              color="blue"
                            >
                              {{ firstLetters(event.deviceType) }}
                            </q-chip>
                            {{ event.device_id }}</div>
                          <div class="col-12">
                            {{ event.created_at | momentFormat }}
                          </div>
                          <div class="col-12">
                            <q-chip
                              v-if="event.deploymentName"
                              dense
                              style="font-weight: bold;"
                              color="primary"
                            >
                              {{ event.deploymentName }}
                            </q-chip>
                          </div>
                          <div class="col-12" v-if="event.rb_data">
                            {{
                              event.rb_data == 1
                                ? "Trap 1 Triggered"
                                : event.rb_data == 2
                                ? "Trap 2 Triggered"
                                : "Both Traps Triggered"
                            }}
                          </div>
                          <div class="col-12" v-if="event.ai_prediction">
                            <q-chip
                              :color="
                                highlightedAIPredictions.includes(
                                  event.ai_prediction
                                ) && event.ai_certainty > 0.85
                                  ? 'negative'
                                  : 'accent'
                              "
                              text-color="white"
                            >
                              {{ getMappedLabel(event.ai_prediction) }}
                              <span style="font-size: 10px" class="q-ml-sm">
                                ({{ event.ai_certainty }})
                              </span>
                            </q-chip>
                          </div>
                        </div>
                      </q-card-section>

                      <span
                        class="batteryPercent"
                        :class="`text-${getBatteryColor(event)}`"
                        v-if="event.battery"
                      >
                        <q-icon name="mdi-battery"></q-icon>
                        {{ event.battery }}v
                        
                      <span
                        class="text-blue text-bold"
                      >
                      &nbsp;&nbsp;&nbsp;[{{ event.triggers }}]
                      </span>
                      </span>

                      <q-btn
                        v-if="!event.rb_data"
                        class="downloadButton"
                        size="sm"
                        unelevated
                        flat
                        text-color="accent"
                        no-caps
                        @click.stop="downloadAttachment(event)"
                      >
                        <q-icon name="mdi-download"></q-icon>
                      </q-btn>
                    </q-card>
                  </div>
                </div>
              </q-scroll-area>
            </div>
          </q-card-section>
          <q-card-section>
            <q-pagination
              color="accent"
              class="justify-center"
              v-model="currentPage"
              :max="Math.ceil(filteredTriggers.length / eventsPerPage)"
              :max-pages="6"
              direction-links
              boundary-links
            />
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="viewDetailsDialog" width="90vw">
      <q-card
        v-touch-swipe.mouse.right.left="handleSwipe"
        class="triggerEventDetails"
        v-if="viewDetailsDialog"
        tile
        ref="el"
        style="width: 90vw; max-width: 1000px; height: 90vh"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Device {{ formData.device_id }}
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-scroll-area style="height: calc(90vh - 60px)">
          <q-card-section
            class="q-pa-none image-container"
            :style="
              `${
                getRotation(formData) == 90 || getRotation(formData) == 270
                  ? 'display: flex; justify-content: center; align-items: center; height: 80vw; max-height: 80vh;'
                  : ''
              }`
            "
          >
            <q-img
              ref="triggerEventImage"
              contain
              :src="
                `https://flexi-comms-trigger-events${
                  apiUrl == 'https://api.flexi-comms.com' ? '-live' : '-live'
                }.s3.ap-southeast-2.amazonaws.com/${formData.id}-triggerEvent.${
                  formData.fileType
                }`
              "
              :style="`rotate: ${getRotation(formData)}deg; ${
                getRotation(formData) == 90 || getRotation(formData) == 270
                  ? 'max-height: 80vh; max-width: 80vw;'
                  : 'max-height: 80vh; max-width: 90vw;'
              }`"
              @load="onImageLoad"
            >
            </q-img>
            <div 
              ref="overlaySVG" 
              v-if="formData.overlays && formData.overlays.length > 0 && shouldShowOverlays(formData)" 
              v-html="svgOverlay" 
              class="overlay"
            ></div>
          </q-card-section>
          <!-- Overlay Controls Section -->
          <q-card-section v-if="formData.overlays && formData.overlays.length > 0 && shouldShowOverlays(formData)" class="q-pa-sm">
            <h6 class="q-my-sm text-accent">Detected Objects</h6>
            <div class="row q-gutter-sm">
              <div v-for="(overlay, index) in formData.overlays" :key="`overlay_${index}`" class="col-auto">
                <q-checkbox
                  v-model="overlayVisibility[index]"
                  :label="`${getMappedLabel(overlay[0])} (${Math.round(overlay[1] * 100)}%)`"
                  @input="updateOverlayVisibility"
                  dense
                />
              </div>
            </div>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-12 q-px-sm">
                <h6 class="q-my-none">Event ID</h6>
                <p>
                  {{ formData.id }}
                </p>
              </div>
              <div class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Server Time</h6>
                <p>
                  {{ formData.created_at | momentFormat }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Device Time</h6>
                <p>
                  {{ formData.invalidDeviceTime | momentFormat }}
                </p>
              </div>
              <div v-if="formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Device Time</h6>
                <p>
                  {{
                    formData.rb_data == 1
                      ? "Trap 1 Triggered"
                      : formData.rb_data == 2
                      ? "Trap 2 Triggered"
                      : "Both Traps Triggered"
                  }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Trigger Count</h6>
                <p>
                  {{ formData.triggers }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Session Number</h6>
                <p>
                  {{ formData.sessions }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 q-px-sm">
                <h6 class="q-my-none">Meta Data</h6>
                <pre>
                {{ formData.metaData }}
              </pre
                >
              </div>
              <div
                v-if="
                  currentUserData.role == 'superAdmin' ||
                    currentUserData.role == 'appAdmin'
                "
                class="col-12 q-px-sm"
              >
                <q-btn
                  flat
                  color="accent"
                  @click="
                    updateHiddenImage(formData.id, formData.imageHidden ? 0 : 1)
                  "
                  :loading="updateHiddenImageLoading"
                >
                  {{ formData.imageHidden ? "Un-hide Image" : "Hide Image" }}
                </q-btn>
                <q-btn
                  class="float-right"
                  flat
                  color="negative"
                  @click="archiveEvent(formData.id)"
                  :loading="archiveEventLoading"
                >
                  Permanently Archive
                </q-btn>
              </div>
            </div>
          </q-card-section>
        </q-scroll-area>
      </q-card>
    </q-dialog>
    <q-dialog v-model="dateRangeDialog" max-width="600px">
      <q-card
        class="dateRangeDialog"
        v-if="dateRangeDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Please select your range
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="dateRangeDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div class="col-6 q-px-sm">
              <q-input
                filled
                label="From"
                v-model="proxyDate.start"
                mask="date"
                :rules="['date']"
              >
                <template>
                  <q-popup-proxy
                    ref="qDateProxy"
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="proxyDate.start">
                      <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Ok" color="primary" flat />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </template>
              </q-input>
            </div>
            <div class="col-6 q-px-sm">
              <q-input
                label="To"
                filled
                v-model="proxyDate.end"
                mask="date"
                :rules="['date']"
              >
                <template>
                  <q-popup-proxy
                    ref="qDateProxy"
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="proxyDate.end">
                      <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Ok" color="primary" flat />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </template>
              </q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="
                  save();
                  dateRangeDialog = false;
                "
                color="primary"
                no-caps
                class="float-right"
              >
                <!-- <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon> -->
                Apply
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {},
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      triggerEvents: "events/triggers",
      triggerEventsLoading: "events/triggersLoading",
      apiUrl: "settings/apiUrl",
      dateRange: "settings/dateRange",
      siteSettings: "settings/siteSettings",
      superAdminBypassOverlaysEnabled: "adminConfig/superAdminBypassOverlaysEnabled",
      showOverlaysByDefault: "settings/showOverlaysByDefault"
    }),
    // Computed property to determine if overlays should be shown
    shouldShowOverlays() {
      return (event) => {
        if (this.superAdminBypassOverlaysEnabled && this.currentUserData.role === 'superAdmin') {
          return true;
        }
        return event.overlaysEnabled == 1;
      };
    }
  },
  watch: {
    triggerEvents: function() {
      this.filterTriggerEvents();
    },
    search: function() {
      this.filterTriggerEvents();
    },
    currentPage: function() {
      this.pagination();
    },
    proxyDate: function() {
      this.save();
    },
    formData: function(newData) {
      if (newData && this.viewDetailsDialog) {
        // Initialize overlay visibility based on showOverlaysByDefault setting
        if (newData.overlays) {
          this.overlayVisibility = {};
          newData.overlays.forEach((overlay, index) => {
            this.$set(this.overlayVisibility, index, this.showOverlaysByDefault);
          });
        }
        
        this.$nextTick(() => {
          this.generateSVGOverlay(newData);
        });
      }
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "device_id",
        label: "Device ID",
        align: "left",
        field: "device_id",
        sortable: true
      },
      {
        name: "type",
        label: "Type",
        align: "left",
        field: "type",
        sortable: true
      },
      {
        name: "sessions",
        label: "Sessions",
        align: "left",
        field: "sessions",
        sortable: true
      },
      {
        name: "triggers",
        label: "Trigger Count",
        align: "left",
        field: "triggers",
        sortable: true
      },
      {
        name: "version",
        label: "Version",
        align: "left",
        field: "version",
        sortable: true
      },
      {
        name: "battery",
        label: "Battery level",
        align: "left",
        field: "battery",
        sortable: true
      },
      {
        name: "temp",
        label: "Temperature",
        align: "left",
        field: "temp",
        sortable: true
      },
      {
        name: "message",
        label: "Message",
        align: "left",
        field: "message",
        sortable: true
      },
      {
        name: "lat",
        label: "Lat",
        align: "left",
        field: "lat",
        sortable: true
      },
      {
        name: "long",
        label: "Long",
        align: "left",
        field: "long",
        sortable: true
      },
      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      }
    ],
    search: "",
    proxyDate: {
      start: new Date(),
      end: new Date()
    },
    startingProxyDate: null,
    endingProxyDate: null,

    viewDetailsDialog: false,
    formData: null,

    dateRangeDialog: false,
    filteredTriggers: [],
    page: [],
    currentPage: 1,
    eventsPerPage: null,
    modelConfig: {
      start: {
        timeAdjust: "00:00:00"
      },
      end: {
        timeAdjust: "23:59:59"
      }
    },
    selectedRelativeDate: "lastTwoWeeks",

    // Filter Array
    filterDialog: false,

    // AI Prediction
    highlightedAIPredictions: [
      "mammal-possum",
      "mammal-rat",
      "mammal-cat",
      "mammal-hedgehog",
      "mammal-stoat",
      "mammal-ferret",
      "mammal-weasel"
    ],
    // AI Label Mapping
    aiLabelMapping: {
      "mammal-possum-body": "Possum",
      "mammal-possum": "Possum",
      "mammal-rat": "Rat",
      "mammal-cat": "Cat",
      "mammal-hedgehog": "Hedgehog",
      "mammal-stoat": "Stoat",
      "mammal-ferret": "Ferret",
      "mammal-weasel": "Weasel"
    },
    updateHiddenImageLoading: false,
    archiveEventLoading: false,
    showHidden: false,

    viewedEventIndex: null,

    isSwiping: null,
    direction: null,
    svgOverlay: "",
    canvasWidth: 0,
    canvasHeight: 0,
    overlayVisibility: {}
  }),
  beforeCreate() {
    this.$store.dispatch("events/loadTriggers");
  },
  mounted() {
    this.eventsPerPage = this.siteSettings.triggerEventsPerPage;
    this.$nextTick(() => {
      this.proxyDate = {
        start: moment(this.dateRange.from)
          .startOf("day")
          .toDate(),
        end: moment(this.dateRange.to)
          .endOf("day")
          .toDate()
      };
    });
    this.filterTriggerEvents();

    window.addEventListener("keydown", e => {
      if (!this.viewDetailsDialog) {
        return;
      }

      if (
        e.key == "ArrowRight" &&
        this.filteredTriggers.length > this.viewedEventIndex + 1
      ) {
        this.viewedEventIndex += 1;
        this.formData = this.filteredTriggers[this.viewedEventIndex];
      } else if (e.key == "ArrowLeft" && this.viewedEventIndex > 0) {
        this.viewedEventIndex -= 1;
        this.formData = this.filteredTriggers[this.viewedEventIndex];
      }
    });
  },
  methods: {
    onImageLoad: function() {
      if (this.formData && this.formData.overlays) {
        this.generateSVGOverlay(this.formData);
      }
    },
    eventClicked: function(event) {
      // Initialize overlay visibility based on showOverlaysByDefault setting
      if (event.overlays) {
        this.overlayVisibility = {};
        event.overlays.forEach((overlay, index) => {
          this.$set(this.overlayVisibility, index, this.showOverlaysByDefault);
        });
      }
      
      // Generate SVG overlay when image loads
      this.$nextTick(() => {
        this.generateSVGOverlay(event);
      });
    },
    toggleOverlaysDefault: function() {
      this.$store.dispatch('settings/toggleShowOverlaysByDefault');
      
      // If we have formData with overlays, update visibility for current view
      if (this.formData && this.formData.overlays) {
        this.formData.overlays.forEach((overlay, index) => {
          this.$set(this.overlayVisibility, index, this.showOverlaysByDefault);
        });
        this.generateSVGOverlay(this.formData);
      }
      
      // Show notification
      this.$q.notify({
        message: `Overlays ${this.showOverlaysByDefault ? 'enabled' : 'disabled'} by default`,
        color: this.showOverlaysByDefault ? 'positive' : 'warning',
        icon: this.showOverlaysByDefault ? 'mdi-eye' : 'mdi-eye-off',
        position: 'top',
        timeout: 2000
      });
    },
    generateSVGOverlay: function(event) {
      if (!this.currentUserData.role.includes("superAdmin")) {
        return;
      }
      if (!event.overlays || event.overlays.length === 0) {
        this.svgOverlay = '';
        return;
      }

      // Wait for image to load to get dimensions
      const imageEl = this.$refs.triggerEventImage;
      if (!imageEl) return;

      // Use a slight delay to ensure image is rendered
      setTimeout(() => {

        const imgElement = imageEl.$el.querySelector('.q-img__image');
        
        if (!imgElement) return;

        const imageWidth = imgElement.clientWidth;
        const imageHeight = imgElement.clientHeight;

        if (imageWidth === 0 || imageHeight === 0) return;

        const rotation = this.getRotation(event);

        // Get the image's position relative to the container
        const containerRect = imgElement.closest('.image-container').getBoundingClientRect();
        const imageRect = imgElement.getBoundingClientRect();
        
        // Calculate offset from container to image
        let offsetX = imageRect.left - containerRect.left;
        let offsetY = imageRect.top - containerRect.top;
        
        // Apply rotation-specific offset adjustments
        if (rotation === 90 || rotation === 270) {
          offsetX += 5;
        }

        // For rotated images, we need to work with the displayed dimensions
        let svgWidth, svgHeight, svgDisplayWidth, svgDisplayHeight;
        if (rotation === 90 || rotation === 270) {
          svgWidth = imageHeight;
          svgHeight = imageWidth;
          svgDisplayWidth = imageHeight;
          svgDisplayHeight = imageWidth;
        } else {
          svgWidth = imageWidth;
          svgHeight = imageHeight;
          svgDisplayWidth = imageWidth;
          svgDisplayHeight = imageHeight;
        }

        // Generate SVG content with exact positioning
        let svgContent = `<svg width="${svgDisplayWidth}px" height="${svgDisplayHeight}px" viewBox="0 0 ${svgWidth} ${svgHeight}" style="position: absolute; top: ${offsetY}px; left: ${offsetX}px; pointer-events: none;">`;
        
        // Sort overlays by confidence (ascending) so higher confidence overlays are drawn last (on top)
        const sortedOverlays = event.overlays
          .map((overlay, index) => ({ overlay, index }))
          .sort((a, b) => {
            // overlay[1] is the confidence score
            const confidenceA = a.overlay[1] || 0;
            const confidenceB = b.overlay[1] || 0;
            return confidenceA - confidenceB; // Ascending order: lowest confidence first
          });
        
        sortedOverlays.forEach(({ overlay, index }) => {
          // Only render overlay if it's visible
          if (this.overlayVisibility[index] !== false && overlay.length >= 6) {
            const [species, confidence, x, y, width, height] = overlay;
            
            // Get mapped label for species
            const mappedSpecies = this.getMappedLabel(species);
            
            // Convert relative coordinates to pixel coordinates (original unrotated positions)
            const originalX = x * imageWidth;
            const originalY = y * imageHeight;
            const originalWidth = width * imageWidth;
            const originalHeight = height * imageHeight;
            
            // Transform coordinates based on rotation to match where they appear on the rotated image
            let transformedX, transformedY, transformedWidth, transformedHeight;
            
            switch (rotation) {
              case 90:
                // 90° clockwise rotation
                transformedX = imageHeight - originalY - originalHeight;
                transformedY = originalX;
                transformedWidth = originalHeight;
                transformedHeight = originalWidth;
                break;
              case 180:
                // 180° rotation
                transformedX = imageWidth - originalX - originalWidth;
                transformedY = imageHeight - originalY - originalHeight;
                transformedWidth = originalWidth;
                transformedHeight = originalHeight;
                break;
              case 270:
                // 270° clockwise (or 90° counter-clockwise) rotation
                transformedX = originalY;
                transformedY = imageWidth - originalX - originalWidth;
                transformedWidth = originalHeight;
                transformedHeight = originalWidth;
                break;
              default: // 0°
                transformedX = originalX;
                transformedY = originalY;
                transformedWidth = originalWidth;
                transformedHeight = originalHeight;
                break;
            }
            
            // Generate a color based on confidence score with thresholds
            // >95% = red, 90-95% = orange, <90% = grey
            const confidenceColor = confidence > 0.95 ? '#ff4444' : confidence >= 0.90 ? '#ff8800' : '#777777';
            
            // Add bounding box rectangle and label
            const labelText = `${mappedSpecies} (${Math.round(confidence * 100)}%)`;
            const labelHeight = 20;
            const labelWidth = Math.max(transformedWidth, labelText.length * 8 + 4);
            
            // Position label above the bounding box if there's space, otherwise below
            let labelX = transformedX;
            let labelY = transformedY >= labelHeight ? transformedY - labelHeight : transformedY + transformedHeight;
            
            // Ensure label stays within SVG bounds (which may be different from image bounds for rotated images)
            if (labelX + labelWidth > svgWidth) {
              labelX = svgWidth - labelWidth;
            }
            if (labelX < 0) labelX = 0;
            if (labelY < 0) labelY = 0;
            if (labelY + labelHeight > svgHeight) {
              labelY = svgHeight - labelHeight;
            }
            
            // Text position within label
            const textX = labelX + 2;
            const textY = labelY + 14;
            
            svgContent += `
              <rect 
                x="${transformedX}" 
                y="${transformedY}" 
                width="${transformedWidth}" 
                height="${transformedHeight}" 
                fill="none" 
                stroke="${confidenceColor}" 
                stroke-width="2" 
                opacity="0.8"
              />
              <rect 
                x="${labelX}" 
                y="${labelY}" 
                width="${labelWidth}" 
                height="${labelHeight}" 
                fill="${confidenceColor}" 
                opacity="0.8"
              />
              <text 
                x="${textX}" 
                y="${textY}" 
                font-family="Arial, sans-serif" 
                font-size="12" 
                fill="white" 
                font-weight="bold"
                dominant-baseline="middle"
              >
                ${labelText}
              </text>
            `;
          }
        });
        
        svgContent += '</svg>';
        this.svgOverlay = svgContent;
      }, 500);
    },
    updateOverlayVisibility: function() {
      // Regenerate the SVG overlay when visibility changes
      if (this.formData) {
        this.generateSVGOverlay(this.formData);
      }
    },
    firstLetters: function(word) {
      if (word == null) {
        return "";
      }
      let words = word.split(" ");
      let initials = "";
      // Max 3 letters
      if (words.length > 3) {
        words = words.slice(0, 3);
      }
      for (let i = 0; i < words.length; i++) {
        initials += words[i].charAt(0).toUpperCase();
      }
      return initials;
    },
    getBatteryColor: function(event) {
      if (!event.battery) {
        return 'positive'; // default green if no battery data
      }
      
      const voltage = parseFloat(event.battery);
      const isMultiTrap = event.deviceType && event.deviceType.toUpperCase().includes('MT');
      
      // Multi-trap cameras have double the thresholds (TODO: confirm values with Lawrence)
      const redThreshold = isMultiTrap ? 13.0 : 6.5;
      const yellowThreshold = isMultiTrap ? 14.0 : 7.0;
      
      if (voltage < redThreshold) {
        return 'negative'; // red
      } else if (voltage < yellowThreshold) {
        return 'warning'; // yellow/orange
      } else {
        return 'positive'; // green
      }
    },
    getMappedLabel: function(species) {
      // Return mapped label if it exists, otherwise return original species name
      return this.aiLabelMapping[species] || species;
    },
    handleSwipe({ ...info }) {
      if (!this.viewDetailsDialog || !info.touch) {
        return;
      }

      if (
        info.direction == "left" &&
        this.filteredTriggers.length > this.viewedEventIndex + 1
      ) {
        this.viewedEventIndex += 1;
        this.formData = this.filteredTriggers[this.viewedEventIndex];
      } else if (info.direction == "right" && this.viewedEventIndex > 0) {
        this.viewedEventIndex -= 1;
        this.formData = this.filteredTriggers[this.viewedEventIndex];
      }
    },
    handleDoubleClick() {},
    save() {
      let date = {
        from: moment(this.proxyDate.start).format("YYYY/MM/DD"),
        to: moment(this.proxyDate.end).format("YYYY/MM/DD")
      };
      this.$store.dispatch("settings/loadDateRange", date);
    },
    saveProxy() {},
    downloadAttachment(event) {
      window.open(
        `${this.apiUrl}/events/downloadAttachment?id=${event.id}&fileType=${event.fileType}&user_guid=${this.currentUserData.downloadGuid}`,
        "_blank"
      );
    },
    filterTriggerEvents() {
      let rows = JSON.parse(JSON.stringify(this.triggerEvents));

      rows = rows.filter(row => {
        let searchFilter = this.search
          ? (
              row.device_id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
              || (row.deploymentName || "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
          )
          : true;

        let showHidden = this.showHidden ? true : !row.imageHidden;
        return searchFilter && showHidden;
      });

      this.filteredTriggers = rows;
      this.pagination();
    },
    pagination() {
      let data = JSON.parse(JSON.stringify(this.filteredTriggers));

      this.page = data.splice(
        (this.currentPage - 1) * this.eventsPerPage,
        this.eventsPerPage
      );
      this.$store.dispatch(
        "settings/changeTriggerEventsPerPage",
        this.eventsPerPage
      );
    },
    handleRelativeDate(range) {
      let start = new Date();
      let end = new Date();
      switch (range) {
        case "yesterday":
          start.setDate(start.getDate() - 1);
          end.setDate(end.getDate() - 1);
          break;
        case "thisWeek":
          start = moment()
            .startOf("week")
            .toDate();
          break;
        case "lastWeek":
          start = moment()
            .subtract(1, "weeks")
            .startOf("week")
            .toDate();
          end = moment()
            .subtract(1, "weeks")
            .endOf("week")
            .toDate();
          break;
        case "lastTwoWeeks":
          start = moment()
            .subtract(1, "weeks")
            .startOf("week")
            .toDate();
          break;
        case "thisMonth":
          start = moment()
            .startOf("month")
            .toDate();
          break;
        case "lastMonth":
          start = moment()
            .subtract(1, "months")
            .startOf("month")
            .toDate();
          end = moment()
            .subtract(1, "months")
            .endOf("month")
            .toDate();
          break;
        default:
          break;
      }

      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      this.proxyDate.start = start;
      this.proxyDate.end = end;
      try {
        this.$refs.datePicker2.updateValue(this.proxyDate);
      } catch (error) {
        console.log(error);
      }
    },
    handleRefresh() {
      if (this.selectedRelativeDate != null) {
        this.handleRelativeDate(this.selectedRelativeDate);
      }
      this.save();
    },
    openFilterDialog() {},
    downloadMultiple() {
      let data = [];

      this.filteredTriggers.forEach((element, index) => {
        if (element.fileType && index < 540) {
          data.push(`f[]=${element.id}.${element.fileType}`);
        }
      });
      window.open(
        `https://${
          this.apiUrl.includes("simplesoftware") ||
          this.apiUrl.includes("simplesoft")
            ? "ffhr2t64w7"
            : "5gqnq5icsg"
        }.execute-api.ap-southeast-2.amazonaws.com/${
          this.apiUrl.includes("simplesoftware") ||
          this.apiUrl.includes("simplesoft")
            ? "dev"
            : "prod"
        }/fileZipper?${data.join("&")}`,
        "_blank"
      );
    },
    updateHiddenImage(id, value) {
      this.updateHiddenImageLoading = true;
      this.$store
        .dispatch("events/updateHiddenImage", {
          id: id,
          value: value
        })
        .then(result => {
          this.updateHiddenImageLoading = false;
          if (result.Result == "Success") {
            this.viewDetailsDialog = false;
            this.handleRefresh();
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: result.Response.Message
            });
          }
        });
    },
    archiveEvent(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to permanently archive the event, are you sure?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      }).then(res => {
        if (res.value) {
          this.archiveEventLoading = true;
          this.$store.dispatch("events/archive", id).then(result => {
            this.archiveEventLoading = false;
            if (result.Result == "Success") {
              this.viewDetailsDialog = false;
              this.handleRefresh();
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message
              });
            }
          });
        }
      });
    },
    getRotation(event) {
      if (event.deviceImageRotation) {
        return event.deviceImageRotation;
      }

      return event.imageRotation ? event.imageRotation : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.triggerEventCard {
  width: 200px;
  height: 300px;
}

.batteryPercent {
  position: absolute;
  bottom: 10px;
  left: 10px;
}

.downloadButton {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.photoGrid {
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 200px);
  grid-gap: 0.5rem;
  justify-content: space-around;
}

.triggerEventDetails {
  h6 {
    color: $accent;
    font-size: 12pt;
    font-weight: bold;
  }
}

.image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

@media (max-width: 630px) {
  .triggerEventCard {
    width: 42vw !important;
    height: 70vw !important;
  }
  .photoGrid {
    grid-template-columns: repeat(auto-fill, 42vw) !important;
  }
}
</style>
